// extracted by mini-css-extract-plugin
module.exports = {"formBox":"styles_formBox__2AFES","setPasswordWrapper":"styles_setPasswordWrapper__2tHTT","forgotLink":"styles_forgotLink__3g9wJ","goBack":"styles_goBack__Z9fIa"};